import React from "react";
import { Tag } from "antd";

const ProducerBadge = ({
                           producer,
                           region
                       }) => {

    return (

        <div>

            <Tag color="green">
                👨‍🌾 {producer}
            </Tag>

            <Tag color="blue">
                📍 {region}
            </Tag>

        </div>
    );
};

export default ProducerBadge;